"use client"

import { useMemo, useEffect } from 'react'
import ResizeObserver from 'resize-observer-polyfill';
import { useAppDispatch } from '../redux';
import { storeActions } from '@/lib/redux/features/store/reduce';

let timeoutResize: any = null

export const useDeviceResize = () => {
  const dispatch = useAppDispatch()

  const ro = useMemo(() => new ResizeObserver((entries) => {
    if (entries.length > 0) {
      const onResize = () => {
        const realWidth = window.innerWidth
        if (realWidth < 992) {
          dispatch(storeActions.setIsDesktop(false))
        } else {
          dispatch(storeActions.setIsDesktop(true))
        }
      }

      if (timeoutResize) clearTimeout(timeoutResize);
      timeoutResize = setTimeout(onResize, 500)
    }
  }), []);

  useEffect(() => {
    ro.observe(document.body)
    return () => {
      ro.unobserve(document.body)
    }
  }, [])
}